import React from "react";

const logs = [
  {
    type: "Add a new customer",
    email: "admin@yourStore.com",
    ip: "172.68.214.94",
    message: "Added a new customer (ID = 29)",
    date: "11/04/2025 1:54:24 AM",
  },
  {
    type: "Add a new customer",
    email: "admin@yourStore.com",
    ip: "172.69.203.170",
    message: "Added a new customer (ID = 27)",
    date: "11/04/2025 1:52:51 AM",
  },
  {
    type: "Add a new customer",
    email: "admin@yourStore.com",
    ip: "104.23.251.116",
    message: "Added a new customer (ID = 23)",
    date: "11/04/2025 1:50:32 AM",
  },
  {
    type: "Delete a gift card",
    email: "admin@yourStore.com",
    ip: "127.0.0.1",
    message: "Deleted a gift card ('bdbbc0ef-be57')",
    date: "02/11/2025 10:34:47 PM",
  },
  {
    type: "Add a new product attribute",
    email: "admin@yourStore.com",
    ip: "127.0.0.1",
    message: "Added a new product attribute ('Some attribute')",
    date: "02/11/2025 10:34:47 PM",
  },
  {
    type: "Edit a specification attribute",
    email: "admin@yourStore.com",
    ip: "127.0.0.1",
    message: "Edited a specification attribute ('CPU Type')",
    date: "02/11/2025 10:34:47 PM",
  },
  {
    type: "Edit a discount",
    email: "admin@yourStore.com",
    ip: "127.0.0.1",
    message: "Edited a discount ('Sample discount with coupon code')",
    date: "02/11/2025 10:34:47 PM",
  },
  {
    type: "Edit category",
    email: "admin@yourStore.com",
    ip: "127.0.0.1",
    message: "Edited a category ('Computers')",
    date: "02/11/2025 10:34:47 PM",
  },
];

export default function ActivityLog() {
  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="max-w-7xl mx-auto bg-white rounded-md shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-semibold">Activity log</h2>
          <button className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded">
            <span className="inline-flex items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5-4h4m-4 0a1 1 0 00-1 1v1h6V4a1 1 0 00-1-1m-4 0h4"
                />
              </svg>
              Clear activity log
            </span>
          </button>
        </div>

        {/* Search Filters */}
        <div className="bg-gray-50 p-6 rounded-md mb-6">
          <form className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
            <div>
              <label className="block font-medium mb-1">
                Created from
                <span className="ml-1 text-blue-500 cursor-pointer" title="Select the start date for filtering">
                  ?
                </span>
              </label>
              <input
                type="date"
                className="border rounded w-full px-3 py-2"
                placeholder="dd-mm-yyyy"
              />
            </div>
            <div>
              <label className="block font-medium mb-1">
                Created to
                <span className="ml-1 text-blue-500 cursor-pointer" title="Select the end date for filtering">
                  ?
                </span>
              </label>
              <input
                type="date"
                className="border rounded w-full px-3 py-2"
                placeholder="dd-mm-yyyy"
              />
            </div>
            <div>
              <label className="block font-medium mb-1">
                Activity log type
                <span className="ml-1 text-blue-500 cursor-pointer" title="Select type of activity log">
                  ?
                </span>
              </label>
              <select className="border rounded w-full px-3 py-2">
                <option>All</option>
                <option>Add a new customer</option>
                <option>Delete a gift card</option>
                <option>Add a new product attribute</option>
                <option>Edit a specification attribute</option>
                <option>Edit a discount</option>
                <option>Edit category</option>
              </select>
            </div>
            <div>
              <label className="block font-medium mb-1">
                IP address
                <span className="ml-1 text-blue-500 cursor-pointer" title="Filter by IP address">
                  ?
                </span>
              </label>
              <input
                type="text"
                className="border rounded w-full px-3 py-2"
                placeholder="IP address"
              />
            </div>
            <div className="md:col-span-4 flex justify-center mt-4">
              <button
                type="submit"
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded w-40 flex items-center justify-center gap-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                Search
              </button>
            </div>
          </form>
        </div>

        {/* Activity Log Table */}
        <p className="mb-3">
          Learn more about{" "}
          <a href="#" className="text-blue-600 underline">
            activity log
          </a>
        </p>
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto border-gray-300 border rounded-lg text-gray-900 text-sm md:text-base">
            <thead>
              <tr className="bg-gray-200">
                <th className="py-3 px-4 text-left font-semibold">Activity log type</th>
                <th className="py-3 px-4 text-left font-semibold">Customer Email</th>
                <th className="py-3 px-4 text-left font-semibold">IP address</th>
                <th className="py-3 px-4 text-left font-semibold">Message</th>
                <th className="py-3 px-4 text-left font-semibold">Created On</th>
                <th className="py-3 px-4 text-center font-semibold">Delete</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                >
                  <td className="py-3 px-4">{log.type}</td>
                  <td className="py-3 px-4 text-blue-600 underline cursor-pointer">{log.email}</td>
                  <td className="py-3 px-4">{log.ip}</td>
                  <td className="py-3 px-4">{log.message}</td>
                  <td className="py-3 px-4">{log.date}</td>
                  <td className="py-3 px-4 text-center">
                    <button className="bg-gray-200 hover:bg-gray-300 rounded px-3 py-1 flex items-center gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5 text-gray-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination and controls */}
        <div className="flex flex-col md:flex-row items-center justify-between mt-6 gap-4">
          <div className="flex items-center gap-2">
            <button className="bg-gray-200 px-4 py-2 rounded cursor-not-allowed">
              Previous
            </button>
            <button className="bg-blue-600 text-white px-4 py-2 rounded">
              1
            </button>
            <button className="bg-gray-200 px-4 py-2 rounded">
              Next
            </button>
          </div>
          <div className="flex items-center gap-2">
            Show
            <select className="border px-3 py-1 rounded">
              <option>15</option>
              <option>30</option>
              <option>45</option>
            </select>
            items
          </div>
          <span className="text-gray-500 text-sm">1-8 of 8 items</span>
          <button className="bg-gray-200 p-2 rounded" title="Refresh">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-gray-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 4v16h16M4 4l16 16"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
